// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Raleway:wght@300;400;500;600;700&display=swap.css);"]);
// Module
exports.push([module.id, ".error-message[data-v-9d682b32]{text-align:center;font-family:var(--font-main);font-size:22px;font-weight:600;letter-spacing:0;color:var(--color)}.error-wrapper[data-v-9d682b32]{background:var(--bg-color) 0 0 no-repeat padding-box;box-shadow:0 3px 6px rgba(0,0,0,.1607843137254902);position:absolute;top:10px;left:10px;right:10px;bottom:auto;z-index:100}", ""]);
// Exports
module.exports = exports;
